var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      _vm.$store.state.authentification.connectUserEmail !== 'colidee@colidee.com'
    )?_c('Header',{attrs:{"window":_vm.window,"parameters":'adminPage'}}):_vm._e(),_c('div',{class:_vm.$store.state.authentification.connectUserEmail !== 'colidee@colidee.com'
        ? _vm.window.width < 480
          ? 'container-fluid'
          : 'container'
        : 'p-3'},[(_vm.adminActiveComponents.searchBar)?_c('SearchBar'):_vm._e(),(_vm.adminActiveComponents.cardList)?_c('CardsList',{attrs:{"window":_vm.window}}):_vm._e(),_c('br'),(_vm.adminActiveComponents.parameters)?_c('Parameters'):_vm._e(),_c('div',{staticClass:"white_space_200"})],1),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),(
      _vm.$store.state.authentification.connectUserEmail !== 'colidee@colidee.com'
    )?_c('Footer',{attrs:{"window":_vm.window}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }